import { DEFAULT_DOMAINS, emailTypoFixer } from "email-typo-fixer";

export const suggestEmail = (email: string, knownDomains: string[] = []) =>
	emailTypoFixer(email, {
		domains: [...DEFAULT_DOMAINS, ...knownDomains],
		domainMatchDistance: 2,
	});
